import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainButton from './MainButton';

// Composant pour afficher une page 404 - Not Found

const NotFound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className='notfound-container'>
            <h1>404 - Page Non Trouvée</h1>
            <img
                src={`./images/penalty-image.png`}
                alt='Penalty Icon'
                className='penalty'
            />
            <p>Désolé, la page que vous recherchez n'existe pas.</p>
            <MainButton
                text="Retour à l'accueil"
                backgroundColor='tertiary'
                onClick={() => {
                    navigate('/');
                }}
            />
        </div>
    );
};

export default NotFound;
